import React from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import './index.css';

function ListOfContactsTitle (props) {

	const { t } = useTranslation();
	const {contactsResults} = props;

	const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
	const contacts = useSelector(state => state.contactReducer.findContacts);
	const contactSearchResult = useSelector(state => state.contactReducer.contactSearchResult);

	if(contactsResults){
		return (
			<div className="list-of-contacts-title">
				{contactSearchResult.contacts.length}
				&nbsp;
				{contactSearchResult.contacts.length > 1 ? t("resultsFound") : t("resultFound")}
			</div>
		)
	} else {
		return (
			<div className="list-of-contacts-title">
				{selectedContactsGroup.name} ({contacts.contacts.length})
			</div>
		)
	}
}

export default ListOfContactsTitle;
